import React from "react";
import { motion } from "framer-motion";

const Avatar = () => {
  return (
    <motion.div
      className="w-40 h-40 rounded-full overflow-hidden border-4 border-gray-300 shadow-lg"
      animate={{
        rotate: [0, 1, -1, 0], // Subtle head tilt
        scale: [1, 1.02, 1], // Small breathing effect
      }}
      transition={{ duration: 2, repeat: Infinity, repeatType: "mirror" }}
    >
      <motion.img
        src='/assets/zyad-avatar.png'
        alt="Avatar"
        className="w-full h-full object-cover"
        animate={{
          y: [0, -2, 0], // Tiny floating effect
        }}
        transition={{ duration: 3, repeat: Infinity, repeatType: "mirror" }}
      />
    </motion.div>
  );
};

export default Avatar;
